"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TalentPoolResponseSchema = exports.TalentPoolResultSchema = exports.TalentPoolDetailSchema = exports.TalentPoolListResponseSchema = exports.TalentPoolListResultSchema = exports.TalentPoolResultItemSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../schemas");
const candidates_list_response_1 = require("../candidates/candidates-list.response");
exports.TalentPoolResultItemSchema = zod_1.z.object({
    id: schemas_1.UUIDSchema,
    name: zod_1.z.string(),
    updatedAt: schemas_1.ISODateTimeSchema,
}).extend({
    membersCount: schemas_1.PositiveIntegerSchema,
});
exports.TalentPoolListResultSchema = zod_1.z
    .object({ lists: exports.TalentPoolResultItemSchema.array() })
    .extend(schemas_1.PaginationResponseSchema.shape);
exports.TalentPoolListResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.TalentPoolListResultSchema);
exports.TalentPoolDetailSchema = exports.TalentPoolResultItemSchema
    .extend({ candidates: candidates_list_response_1.CandidateSearchResultItemSchema.array() })
    .extend(schemas_1.PaginationResponseSchema.shape);
exports.TalentPoolResultSchema = zod_1.z.object({ pool: exports.TalentPoolDetailSchema });
exports.TalentPoolResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.TalentPoolResultSchema);
